module.exports = __webpack_public_path__ + "img/ps.383cd294.jpg";